import React from 'react';
import LogoPNG from './logo.png';
import LogoMps from './mps_logo.svg';
import * as styles from './Logo.module.css';
import { isMadPawsStore } from '../../../common/util';

const Logo = () => {
  return (
    <>
      <img className={styles.Logo} src={isMadPawsStore() ? LogoMps : LogoPNG} alt="" />
      <img
        className={isMadPawsStore() ? styles.logoMobileMps : styles.logoMobile}
        src={isMadPawsStore() ? LogoMps : '/logo-mobile.png'}
        alt=""
      />
    </>
  );
};

export default Logo;
